<vb-button
    *ngIf="(isAdmin$ | async) && auction"
    variant="primary"
    size="md"
    [fullWidth]="fullWidth"
    (clicked)="openSummary()">
    Auction summary
</vb-button>

<!-- Auction summary dialog (library shell + totals ledger). attachToBody:
     on the lot list page this component is projected into the sticky
     breadcrumb bar, whose transform would otherwise trap the fixed scrim. -->
<vb-dialog
    [open]="summaryOpen"
    [eyebrow]="summaryEyebrow"
    title="Auction Summary"
    [attachToBody]="true"
    (closed)="summaryOpen = false">
    <div *ngIf="isLoadingSummary" class="vb-summary-loading">
        <vb-spinner size="l" label="Loading summary"></vb-spinner>
    </div>
    <vb-totals
        *ngIf="!isLoadingSummary && summaryRows.length"
        [rows]="summaryRows"></vb-totals>
    <p *ngIf="!isLoadingSummary && summaryError">{{ summaryError }}</p>
    <vb-button
        dialogFooter
        variant="secondary"
        [fullWidth]="true"
        (clicked)="summaryOpen = false">
        Close
    </vb-button>
</vb-dialog>
